import Vue from "vue";
const base_uri = process.env.VUE_APP_BASE_PRODUCTS_API;


export async function autocompleteBarcode(barcode) {
  const response = await Vue.prototype.$http.get(`${base_uri}/products/ean/${barcode}`);

  return response.data;
}

export async function index(params) {
  const response = await Vue.prototype.$http.post(`${base_uri}/products`, params);

  return response.data;
}

export async function show(id) {
  const response = await Vue.prototype.$http.get(`${base_uri}/products/${id}`);

  return response.data;
}